import { render } from "./BadgeComp.vue?vue&type=template&id=009e3e4c"
import script from "./BadgeComp.vue?vue&type=script&lang=js"
export * from "./BadgeComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__